<template>
	<div>
		<!-- SEARCH DESKTOP-->
		<div class="border radius-0 mobile-none box-shadow-ota-2" :class="{'z-index-1040 position-relative bg-white':!(backdrop == '' || backdrop == 'cr_lang')}">
			<div class="row slim-grid-row">
				<div class="col-3 border-right py-4 align-self-center position-relative">
					<div class="pl-3" >
						<div class="row no-gutters">
							<div class="col-1 align-self-center none-1024">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 10.3178C3.5 5.71789 7.34388 2 11.9934 2C16.6561 2 20.5 5.71789 20.5 10.3178C20.5 12.6357 19.657 14.7876 18.2695 16.6116C16.7388 18.6235 14.8522 20.3765 12.7285 21.7524C12.2425 22.0704 11.8039 22.0944 11.2704 21.7524C9.13474 20.3765 7.24809 18.6235 5.7305 16.6116C4.34198 14.7876 3.5 12.6357 3.5 10.3178ZM9.19423 10.5768C9.19423 12.1177 10.4517 13.3297 11.9934 13.3297C13.5362 13.3297 14.8058 12.1177 14.8058 10.5768C14.8058 9.0478 13.5362 7.77683 11.9934 7.77683C10.4517 7.77683 9.19423 9.0478 9.19423 10.5768Z" fill="#999999"/>
								</svg>
							</div>
							<div class="col-10 col-lg-10 col-xl-10" @click="toggleBackdrop('merchant')">
								<div class="pl-2 cursor-pointer" style="height:44px">
									<p class="mb-0 font-semibold text-13 color-grey">Property</p>
									<div>
										<p class="mb-0 body-2" v-if="!filter.merchant.selected.id">Choose Property</p>
										<p class="mb-0 body-2-1" v-else>{{ filter.merchant.selected.name }}</p>
									</div>
									<!-- <select v-model="filter.merchant.selected" class="ota-property-select text-14 font-semibold text-semi-dark text-truncate">
									  <option disabled :value="{name:'Choose property'}" class="mb-2 body-2">Choose property</option>
									  <option v-for="property in filter.merchant.list" :value="property">{{property.name}}</option>
									</select> -->
								</div>
							</div>
							<div class="col-1 align-self-center">
								<img v-if="filter.merchant.selected.id" @click="selectMerchant({})" class="cursor-pointer" src="../../assets/img/icon/close.png" width="10" />
								<svg v-else width="14" class="svg-property" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" @click="selectMerchant({})">
									<path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"/>
								</svg>
							</div>
						</div>
					</div>
					<div class="ota-property-select w-100 pl-2" v-if="filter.merchant.show_detail && backdrop == 'merchant'">
						<div class="rounded-4 bg-white border-semi-grey w-100" style="max-height: 60vh; overflow-y: auto;">
							<div 
								class="w-100 p-3 ota-property-select-item" 
								v-for="merchant in filter.merchant.list" 
								:class="{'active-item':filter.merchant.selected.id && merchant.id == filter.merchant.selected.id}"
								@click="selectMerchant(merchant)">
								<p class="mb-0 body-2-1">{{ merchant.name }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-3 border-right py-4 align-self-center">
					<div class="row no-gutters">
						<div class="col-1 align-self-center none-1024">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M16.4109 2.76862L16.4119 3.51824C19.1665 3.73413 20.9862 5.61119 20.9891 8.48975L21 16.9155C21.0039 20.054 19.0322 21.985 15.8718 21.99L8.15188 22C5.01119 22.004 3.01482 20.027 3.01087 16.8795L3.00001 8.55272C2.99606 5.65517 4.75153 3.78311 7.50617 3.53024L7.50518 2.78061C7.5042 2.34083 7.83001 2.01 8.26444 2.01C8.69886 2.009 9.02468 2.33883 9.02567 2.77861L9.02666 3.47826L14.8914 3.47027L14.8904 2.77062C14.8894 2.33084 15.2152 2.001 15.6497 2C16.0742 1.999 16.4099 2.32884 16.4109 2.76862ZM4.52148 8.86157L19.4696 8.84158V8.49175C19.4272 6.34283 18.349 5.21539 16.4138 5.04748L16.4148 5.81709C16.4148 6.24688 16.0801 6.5877 15.6556 6.5877C15.2212 6.5887 14.8943 6.24887 14.8943 5.81909L14.8934 5.0095L9.02863 5.01749L9.02962 5.82609C9.02962 6.25687 8.70479 6.5967 8.27036 6.5967C7.83594 6.5977 7.50913 6.25887 7.50913 5.82809L7.50815 5.05847C5.58286 5.25137 4.51753 6.38281 4.52049 8.55072L4.52148 8.86157ZM15.2399 13.4043V13.4153C15.2498 13.8751 15.625 14.2239 16.0801 14.2139C16.5244 14.2029 16.8789 13.8221 16.869 13.3623C16.8483 12.9225 16.4918 12.5637 16.0485 12.5647C15.5944 12.5747 15.2389 12.9445 15.2399 13.4043ZM16.0554 17.892C15.6013 17.882 15.235 17.5032 15.234 17.0435C15.2241 16.5837 15.5884 16.2029 16.0426 16.1919H16.0525C16.5165 16.1919 16.8927 16.5707 16.8927 17.0405C16.8937 17.5102 16.5185 17.891 16.0554 17.892ZM11.1721 13.4203C11.1919 13.8801 11.568 14.2389 12.0222 14.2189C12.4665 14.1979 12.821 13.8181 12.8012 13.3583C12.7903 12.9085 12.425 12.5587 11.9807 12.5597C11.5266 12.5797 11.1711 12.9605 11.1721 13.4203ZM12.0262 17.8471C11.572 17.8671 11.1968 17.5082 11.1761 17.0485C11.1761 16.5887 11.5305 16.2089 11.9847 16.1879C12.429 16.1869 12.7953 16.5367 12.8052 16.9855C12.8259 17.4463 12.4705 17.8261 12.0262 17.8471ZM7.10433 13.4553C7.12408 13.915 7.50025 14.2749 7.95442 14.2539C8.39872 14.2339 8.75317 13.8531 8.73243 13.3933C8.72256 12.9435 8.35725 12.5937 7.91196 12.5947C7.45779 12.6147 7.10334 12.9955 7.10433 13.4553ZM7.95837 17.8521C7.5042 17.8731 7.12901 17.5132 7.10828 17.0535C7.10729 16.5937 7.46273 16.2129 7.9169 16.1929C8.3612 16.1919 8.7275 16.5417 8.73737 16.9915C8.7581 17.4513 8.40365 17.8321 7.95837 17.8521Z" fill="#999999"/>
							</svg>
						</div>
						<div class="col-10 col-lg-10 col-xl-10">
							<div class="pl-2" @click="toggleBackdrop('date')">
								<p class="mb-0 font-regular text-13 color-grey">Check in - Check out</p>
								<CalendarRoom 
									v-if="getCompanyType == 'MERCHANT'"
									:date_default="filter.date.form"
									:filter_guest="filter.guest"
									@finish="applyDateFilter"
									wrapper_class="calendar-be calendar-be-active  text-14 font-semibold text-semi-dark mt-3px z-index-1038 d-inline-block align-top">
								</CalendarRoom>
								<div v-if="getCompanyType == 'COMMUNITY'" class="calendar-ota calendar-ota-active text-14 font-semibold text-semi-dark mt-3px z-index-1038 d-inline-block align-top">
									<date-range-picker ref="picker1" style="height: 0;"
							      :min-date="filter.date.min" 
							      v-model="filter.date.form" 
							      opens="right" 
							      :show-dropdowns="false" 
							      :auto-apply="true" 
							      :ranges="false"
							      :single-date-picker="false">
							      <template v-slot:input="picker">
											{{ $formatDateRange(filter.date.form.startDate,filter.date.form.endDate) }}
							      </template>
							      <template #date="data">
							      	<div class="pt-2 calendar-be-custom-date">
										    <p class="font-semibold text-16 lh-1 mb-0">{{formatDateNumber(data.date)}}</p>
										  </div>
							      </template>
							    </date-range-picker>
							  </div>
							</div>
						</div>
						<div class="col-1 align-self-center">
							<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"/>
							</svg>
						</div>
					</div>
				</div>
				<div class="col-2 border-right py-4 align-self-center">
					<div class="row no-gutters cursor-pointer" @click="toggleBackdrop('guest')">
						<div class="col-2 align-self-center none-1024">
							<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M14.7597 7.76241C14.7597 10.4062 12.5963 12.5248 9.8967 12.5248C7.19806 12.5248 5.03367 10.4062 5.03367 7.76241C5.03367 5.11865 7.19806 3 9.8967 3C12.5963 3 14.7597 5.11865 14.7597 7.76241ZM2.54736 17.9174C2.54736 15.47 5.93289 14.8577 9.8967 14.8577C13.882 14.8577 17.246 15.4911 17.246 17.9404C17.246 20.3877 13.8605 21 9.8967 21C5.91136 21 2.54736 20.3666 2.54736 17.9174ZM16.7208 7.84875C16.7208 9.19506 16.3079 10.4513 15.5838 11.4948C15.5085 11.6021 15.575 11.7468 15.7061 11.7698C15.8881 11.7995 16.075 11.8177 16.2658 11.8216C18.164 11.8704 19.8676 10.6736 20.3382 8.87118C21.0359 6.19676 18.9889 3.79543 16.3813 3.79543C16.0985 3.79543 15.8274 3.82418 15.5632 3.87688C15.527 3.88454 15.4879 3.90179 15.4683 3.93246C15.4429 3.97174 15.4615 4.02253 15.4869 4.05607C16.2707 5.13216 16.7208 6.44206 16.7208 7.84875ZM19.8646 13.7023C21.1406 13.9466 21.9791 14.444 22.3265 15.1694C22.621 15.7635 22.621 16.4534 22.3265 17.0475C21.7952 18.1705 20.0809 18.5318 19.4145 18.6247C19.2766 18.6439 19.166 18.5289 19.1807 18.3928C19.5212 15.2805 16.8137 13.8048 16.1131 13.4656C16.0838 13.4493 16.0769 13.4263 16.0799 13.411C16.0818 13.4014 16.0946 13.3861 16.1171 13.3832C17.6327 13.3545 19.2629 13.5586 19.8646 13.7023Z" fill="#999999"/>
							</svg>
						</div>
						<div class="col-10 col-lg-10 col-xl-8">
							<p class="mb-0 font-regular text-13 color-grey">Guest</p>
							<p class="mb-0 text-14 font-semibold text-semi-dark text-truncate mt-3px">{{ filter.guest.adult }} {{$pluralWord(filter.guest.adult,'Adult')}}, {{ filter.guest.child }} {{$pluralWord(filter.guest.child,'Child')}}, {{ filter.guest.infant }} {{$pluralWord(filter.guest.infant,'Infant')}}</p>
						</div>
						<div class="col-2 align-self-center text-right ">
							<svg width="14" class="position-relative" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"/>
							</svg>
						</div>
					</div>
				</div>
				<div class="col-2 border-right py-4 align-self-center">
					<div class="row no-gutters cursor-pointer" @click="toggleBackdrop('promo')">
						<div class="col-2 align-self-center none-1024">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M20.3992 9.14599L21.1194 9.86599C21.6897 10.426 21.9998 11.186 21.9998 11.986C22.0098 12.786 21.6997 13.547 21.1395 14.116C21.1328 14.1233 21.1261 14.1298 21.1194 14.1362C21.1161 14.1394 21.1128 14.1427 21.1094 14.146L20.3992 14.856C20.1191 15.136 19.959 15.516 19.959 15.917V16.946C19.959 18.606 18.6085 19.957 16.9479 19.957H15.9176C15.5174 19.957 15.1373 20.116 14.8572 20.396L14.1369 21.116C13.5467 21.707 12.7764 21.996 12.0061 21.996C11.2359 21.996 10.4656 21.707 9.87537 21.127L9.14511 20.396C8.865 20.116 8.48487 19.957 8.08472 19.957H7.05435C5.39375 19.957 4.04326 18.606 4.04326 16.946V15.917C4.04326 15.516 3.8832 15.136 3.6031 14.846L2.88284 14.136C1.71241 12.967 1.70241 11.056 2.87283 9.87699L3.6031 9.14599C3.8832 8.86599 4.04326 8.48599 4.04326 8.07599V7.05599C4.04326 5.39599 5.39375 4.04699 7.05435 4.04699H8.08472C8.48487 4.04699 8.865 3.88599 9.14511 3.60599L9.86537 2.88599C11.0358 1.70699 12.9465 1.70699 14.1269 2.87699L14.8572 3.60599C15.1373 3.88599 15.5174 4.04699 15.9176 4.04699H16.9479C18.6085 4.04699 19.959 5.39599 19.959 7.05599V8.08699C19.959 8.48599 20.1191 8.86599 20.3992 9.14599ZM9.42521 15.446C9.66529 15.446 9.88537 15.356 10.0454 15.186L15.1873 10.047C15.5274 9.70699 15.5274 9.14599 15.1873 8.80599C14.8472 8.46699 14.297 8.46699 13.9569 8.80599L8.81499 13.946C8.47486 14.286 8.47486 14.846 8.81499 15.186C8.97504 15.356 9.19512 15.446 9.42521 15.446ZM13.6968 14.566C13.6968 15.056 14.0869 15.446 14.5771 15.446C15.0572 15.446 15.4474 15.056 15.4474 14.566C15.4474 14.087 15.0572 13.696 14.5771 13.696C14.0869 13.696 13.6968 14.087 13.6968 14.566ZM9.43521 8.55599C9.91539 8.55599 10.3055 8.94599 10.3055 9.42599C10.3055 9.91699 9.91539 10.306 9.43521 10.306C8.95504 10.306 8.55489 9.91699 8.55489 9.42599C8.55489 8.94599 8.95504 8.55599 9.43521 8.55599Z" fill="#999999"/>
							</svg>
						</div>
						<div class="col-10 col-lg-10 col-xl-8">
							<p class="mb-0 font-regular text-13 color-grey">Promo</p>
							<p class="mb-0 text-14 font-semibold text-semi-dark text-truncate mt-3px">{{ filter.promo_code == '' ? '-':filter.promo_code }}</p>
						</div>
						<div class="col-2 align-self-center text-right">
							<svg width="14" height="14" class="position-relative" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"/>
							</svg>
						</div>
					</div>
				</div>
				<div class="col-2 align-self-center">
					<div class="px-3">
						<button class="w-100 border-none g-btn-lg radius-0" :class="getCompanyType=='COMMUNITY'?'g-btn-primary-ota':'g-btn g-btn-primary'" type="button" @click="hitSearch()">
							<svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="7.84442" cy="7.84442" r="5.99237" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M12.0122 12.3235L14.3616 14.6667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<span>Search</span>
						</button>
					</div>
				</div>
				<div class="col-3"></div>
				<div class="col-3"></div>
				<div class="col-3">
					<div
            class="position-absolute bg-white border rounded-6 px-3 py-2 box-shadow-primary rooms-guest z-index-1039"
            style="top: -20px;left: 20px;width: 310px" v-if="backdrop == 'guest'">
            <div class="">
              <div class="row pt-2 pb-3 mb-2 no-gutters border-bottom">
                <div class="col-7">
                  <p class="mb-0 body-2-2 font-bold text-14">{{$t('hotel.adults.adults')}}</p>
                  <p class="mb-0 body-2-2 font-regular text-13">Ages 17 or above</p>
                </div>
                <div class="col-5 text-center mt-1">
                  <div class="row py-1 text-right w-100 no-gutters">
                    <div class="col-4 text-center">
                      <img src="../../assets/img/icon/decrement.png"
                        class="cursor-disable border rounded-100 p-2" width="30"
                        v-if="filter.guest.adult <= 1">
                      <img src="../../assets/img/icon/minus-black.png"
                        class="cursor-pointer border rounded-100 p-2" width="30" v-else
                        @click="changeQtyGuest('adult','minus')">
                    </div>
                    <div class="col-4 text-center">
                      <p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;left:6px">
                        {{filter.guest.adult}}</p>
                    </div>
                    <div class="col-4 text-center">
                      <img src="../../assets/img/icon/plus-black.png"
                        class="cursor-pointer border rounded-100 p-2" width="30"
                        @click="changeQtyGuest('adult','plus')">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2 pb-3 my-2 no-gutters border-bottom">
                <div class="col-7">
                  <p class="mb-0 body-2-2 font-bold text-14">{{$t('hotel.children.children')}}</p>
                  <p class="mb-0 body-2-2 font-regular text-13">Ages 2 - 16</p>
                </div>
                <div class="col-5 text-center mt-1">
                  <div class="row py-1 text-right w-100 no-gutters">
                    <div class="col-4 text-center">
                      <img src="../../assets/img/icon/decrement.png"
                        class="cursor-disable border rounded-100 p-2" width="30"
                        v-if="filter.guest.child == 0">
                      <img src="../../assets/img/icon/minus-black.png"
                        class="cursor-pointer border rounded-100 p-2" width="30" v-else
                        @click="changeQtyGuest('child','minus')">
                    </div>
                    <div class="col-4 text-center">
                      <p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;left:6px">
                        {{filter.guest.child}}</p>
                    </div>
                    <div class="col-4 text-center">
                      <img src="../../assets/img/icon/plus-black.png"
                        class="cursor-pointer border rounded-100 p-2" width="30"
                        @click="changeQtyGuest('child','plus')">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div class="row py-2 no-gutters">
                <div class="col-7">
                  <p class="mb-0 body-2-2 font-bold text-14">{{$t('hotel.infants.infants')}}</p>
                  <p class="mb-0 body-2-2 font-regular text-13">Under 2</p>
                </div>
                <div class="col-5 text-center mt-1">
                  <div class="row py-1 text-right w-100 no-gutters mt-2">
                    <div class="col-4 text-center">
                      <img src="../../assets/img/icon/decrement.png"
                        class="cursor-disable border rounded-100 p-2" width="30"
                        v-if="filter.guest.infant == 0">
                      <img src="../../assets/img/icon/minus-black.png"
                        class="cursor-pointer border rounded-100 p-2" width="30" v-else
                        @click="changeQtyGuest('infant','minus')">
                    </div>
                    <div class="col-4 text-center">
                      <p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;left:6px">
                        {{filter.guest.infant}}</p>
                    </div>
                    <div class="col-4 text-center">
                      <img src="../../assets/img/icon/plus-black.png"
                        class="cursor-pointer border rounded-100 p-2" width="30"
                        @click="changeQtyGuest('infant','plus')">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
				</div>
				<div class="col-3">
					<div
            class="position-absolute bg-white border rounded-6 px-3 py-2 box-shadow-primary rooms-guest z-index-1039"
            style="top: -20px;left: -90px" v-if="backdrop == 'promo'">
            <div class="">
              <div class="row py-2 mb-2 no-gutters">
                <div class="col-12">
                  <p class="mb-2 body-2-2 font-bold text-14">{{$t('hotel.promo.promo-code')}}</p>
                  <input type="text" class="form-control body-2-2 font-semibold"
                    v-model="filter.promo_code" :placeholder="$t('general.input-here')" value="promo_code" />
                </div>
              </div>
            </div>
          </div>
				</div>
			</div>
		</div>

		<!-- SEARCH MOBILE -->
		<popup-detail 
			:show="mobile.show"
			direction="bottom" 
			:size="100"
			@close="toggleMobileView">
			<template v-slot:body>
				<div class="px-4 py-3 border-bottom position-fixed w-100 bg-white z-index-1045" style="top:14px">
					<div class="row">
						<div class="col-10">
							<p class="mb-0 font-bold text-16 mt-1 text-semi-dark">Find Your Destination</p>
							<p class="mb-0 font-regular text-13 color-grey">Filter the date according to your wishes</p>
						</div>
						<div class="col-2 text-right">
							<svg width="34" height="34" @click="toggleMobileView()" class="position-relative cursor-pointer" style="top: 7px;" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="0.5" y="0.5" width="33" height="33" rx="6.5" fill="white"/>
								<path d="M23.7998 11.21L22.3898 9.80005L16.7998 15.39L11.2098 9.80005L9.7998 11.21L15.3898 16.8L9.7998 22.39L11.2098 23.8L16.7998 18.21L22.3898 23.8L23.7998 22.39L18.2098 16.8L23.7998 11.21Z" fill="#222222"/>
								<rect x="0.5" y="0.5" width="33" height="33" rx="6.5" stroke="#DDDDDD"/>
							</svg>
						</div>
					</div>
				</div>
				<div class="p-4" style="margin-top:100px">
					<div class="">
						<!-- MERCHANT -->
						<div class="p-3 align-self-center bg-white border rounded-6 mb-2 box-shadow-ota-1">
							<div class="row no-gutters" @click="toggleMobileCollapse('merchant')">
								<div class="col-1 align-self-center">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 10.3178C3.5 5.71789 7.34388 2 11.9934 2C16.6561 2 20.5 5.71789 20.5 10.3178C20.5 12.6357 19.657 14.7876 18.2695 16.6116C16.7388 18.6235 14.8522 20.3765 12.7285 21.7524C12.2425 22.0704 11.8039 22.0944 11.2704 21.7524C9.13474 20.3765 7.24809 18.6235 5.7305 16.6116C4.34198 14.7876 3.5 12.6357 3.5 10.3178ZM9.19423 10.5768C9.19423 12.1177 10.4517 13.3297 11.9934 13.3297C13.5362 13.3297 14.8058 12.1177 14.8058 10.5768C14.8058 9.0478 13.5362 7.77683 11.9934 7.77683C10.4517 7.77683 9.19423 9.0478 9.19423 10.5768Z" fill="#999999"/>
									</svg>
								</div>
								<div class="col-10">
									<div class="pl-2" style="height:44px">
										<p class="mb-0 font-semibold text-13 color-grey">Property</p>
										<p class="mb-0 body-2" v-if="!filter.merchant.selected.id">Choose Property</p>
										<p class="mb-0 body-2-1" v-else>{{ filter.merchant.selected.name }}</p>
									</div>
								</div>
								<div class="col-1 align-self-center">
									<img v-if="filter.merchant.selected.id" @click="selectMerchant({})" class="cursor-pointer" src="../../assets/img/icon/close.png" width="10" />
									<svg v-else width="14" class="svg-property" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" @click="selectMerchant({})">
										<path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"/>
									</svg>
								</div>
							</div>

							<div class="w-100" v-if="mobile.collapse == 'merchant'">
								<div class="">
									<div 
										class="w-100 p-3 ota-property-select-item" 
										v-for="merchant in filter.merchant.list" 
										:class="{'active-item':filter.merchant.selected.id && merchant.id == filter.merchant.selected.id}"
										@click="selectMerchant(merchant)">
										<p class="mb-0 body-2-1">{{ merchant.name }}</p>
									</div>
								</div>
							</div>
						</div>

						<!-- DATE -->
						<div class="p-3 align-self-center bg-white border rounded-6 mb-2 box-shadow-ota-1">
							<div class="row no-gutters">
								<div class="col-1 align-self-center" @click="toggleMobileCollapse('date')">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M16.4109 2.76862L16.4119 3.51824C19.1665 3.73413 20.9862 5.61119 20.9891 8.48975L21 16.9155C21.0039 20.054 19.0322 21.985 15.8718 21.99L8.15188 22C5.01119 22.004 3.01482 20.027 3.01087 16.8795L3.00001 8.55272C2.99606 5.65517 4.75153 3.78311 7.50617 3.53024L7.50518 2.78061C7.5042 2.34083 7.83001 2.01 8.26444 2.01C8.69886 2.009 9.02468 2.33883 9.02567 2.77861L9.02666 3.47826L14.8914 3.47027L14.8904 2.77062C14.8894 2.33084 15.2152 2.001 15.6497 2C16.0742 1.999 16.4099 2.32884 16.4109 2.76862ZM4.52148 8.86157L19.4696 8.84158V8.49175C19.4272 6.34283 18.349 5.21539 16.4138 5.04748L16.4148 5.81709C16.4148 6.24688 16.0801 6.5877 15.6556 6.5877C15.2212 6.5887 14.8943 6.24887 14.8943 5.81909L14.8934 5.0095L9.02863 5.01749L9.02962 5.82609C9.02962 6.25687 8.70479 6.5967 8.27036 6.5967C7.83594 6.5977 7.50913 6.25887 7.50913 5.82809L7.50815 5.05847C5.58286 5.25137 4.51753 6.38281 4.52049 8.55072L4.52148 8.86157ZM15.2399 13.4043V13.4153C15.2498 13.8751 15.625 14.2239 16.0801 14.2139C16.5244 14.2029 16.8789 13.8221 16.869 13.3623C16.8483 12.9225 16.4918 12.5637 16.0485 12.5647C15.5944 12.5747 15.2389 12.9445 15.2399 13.4043ZM16.0554 17.892C15.6013 17.882 15.235 17.5032 15.234 17.0435C15.2241 16.5837 15.5884 16.2029 16.0426 16.1919H16.0525C16.5165 16.1919 16.8927 16.5707 16.8927 17.0405C16.8937 17.5102 16.5185 17.891 16.0554 17.892ZM11.1721 13.4203C11.1919 13.8801 11.568 14.2389 12.0222 14.2189C12.4665 14.1979 12.821 13.8181 12.8012 13.3583C12.7903 12.9085 12.425 12.5587 11.9807 12.5597C11.5266 12.5797 11.1711 12.9605 11.1721 13.4203ZM12.0262 17.8471C11.572 17.8671 11.1968 17.5082 11.1761 17.0485C11.1761 16.5887 11.5305 16.2089 11.9847 16.1879C12.429 16.1869 12.7953 16.5367 12.8052 16.9855C12.8259 17.4463 12.4705 17.8261 12.0262 17.8471ZM7.10433 13.4553C7.12408 13.915 7.50025 14.2749 7.95442 14.2539C8.39872 14.2339 8.75317 13.8531 8.73243 13.3933C8.72256 12.9435 8.35725 12.5937 7.91196 12.5947C7.45779 12.6147 7.10334 12.9955 7.10433 13.4553ZM7.95837 17.8521C7.5042 17.8731 7.12901 17.5132 7.10828 17.0535C7.10729 16.5937 7.46273 16.2129 7.9169 16.1929C8.3612 16.1919 8.7275 16.5417 8.73737 16.9915C8.7581 17.4513 8.40365 17.8321 7.95837 17.8521Z" fill="#999999"/>
									</svg>
								</div>
								<div class="col-10 col-lg-10 col-xl-10" @click="toggleMobileCollapse('date')">
									<div class="pl-2">
										<p class="mb-0 font-regular text-13 color-grey">Check in - Check out</p>
										<p class="mb-0 text-14 font-semibold text-semi-dark mt-3px z-index-1038 d-inline-block align-top text-truncate w-95">{{ $formatDateRange(filter.date.form.startDate,filter.date.form.endDate) }}</p>
									</div>
								</div>
								<div class="col-1 align-self-center" @click="toggleMobileCollapse('date')">
									<svg width="14" height="14" class="svg-property position-relative" :class="{'transform-180':mobile.collapse == 'date'}" viewBox="0 0 14 14"  fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"/>
									</svg>
								</div>
								<div class="col-12" v-if="mobile.collapse == 'date'">
									<div class="calendar-ota calendar-ota-active scroll-hide-mobile pt-2 pb-4" style="overflow-x: scroll;">
										<date-range-picker
											:min-date="filter.date.min" 
											v-model="filter.date.form" 
											:show-dropdowns="false" 
											:auto-apply="true" 
											:ranges="false"
											opens="inline"
											single-date-picker="range">
											<template #date="data">
												<div class="pt-2 calendar-ota-custom-date">
													<p class="font-semibold text-12 lh-1 mb-0">{{formatDateNumber(data.date)}}</p>
												</div>
											</template>
										</date-range-picker>
									</div>
								</div>
							</div>
						</div>

						<!-- GUEST -->
						<div class="p-3 align-self-center bg-white border rounded-6 mb-2 box-shadow-ota-1">
							<div class="row no-gutters cursor-pointer">
								<div class="col-1 align-self-center" @click="toggleMobileCollapse('guest')">
									<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M14.7597 7.76241C14.7597 10.4062 12.5963 12.5248 9.8967 12.5248C7.19806 12.5248 5.03367 10.4062 5.03367 7.76241C5.03367 5.11865 7.19806 3 9.8967 3C12.5963 3 14.7597 5.11865 14.7597 7.76241ZM2.54736 17.9174C2.54736 15.47 5.93289 14.8577 9.8967 14.8577C13.882 14.8577 17.246 15.4911 17.246 17.9404C17.246 20.3877 13.8605 21 9.8967 21C5.91136 21 2.54736 20.3666 2.54736 17.9174ZM16.7208 7.84875C16.7208 9.19506 16.3079 10.4513 15.5838 11.4948C15.5085 11.6021 15.575 11.7468 15.7061 11.7698C15.8881 11.7995 16.075 11.8177 16.2658 11.8216C18.164 11.8704 19.8676 10.6736 20.3382 8.87118C21.0359 6.19676 18.9889 3.79543 16.3813 3.79543C16.0985 3.79543 15.8274 3.82418 15.5632 3.87688C15.527 3.88454 15.4879 3.90179 15.4683 3.93246C15.4429 3.97174 15.4615 4.02253 15.4869 4.05607C16.2707 5.13216 16.7208 6.44206 16.7208 7.84875ZM19.8646 13.7023C21.1406 13.9466 21.9791 14.444 22.3265 15.1694C22.621 15.7635 22.621 16.4534 22.3265 17.0475C21.7952 18.1705 20.0809 18.5318 19.4145 18.6247C19.2766 18.6439 19.166 18.5289 19.1807 18.3928C19.5212 15.2805 16.8137 13.8048 16.1131 13.4656C16.0838 13.4493 16.0769 13.4263 16.0799 13.411C16.0818 13.4014 16.0946 13.3861 16.1171 13.3832C17.6327 13.3545 19.2629 13.5586 19.8646 13.7023Z" fill="#999999"/>
									</svg>
								</div>
								<div class="col-10 col-lg-10 col-xl-8" @click="toggleMobileCollapse('guest')">
									<div class="pl-2">
										<p class="mb-0 font-regular text-13 color-grey">Guest</p>
										<p class="mb-0 text-14 font-semibold text-semi-dark text-truncate mt-3px">{{ filter.guest.adult }} {{$pluralWord(filter.guest.adult,'Adult')}}, {{ filter.guest.child }} {{$pluralWord(filter.guest.child,'Child')}}, {{ filter.guest.infant }} {{$pluralWord(filter.guest.infant,'Infant')}}</p>
									</div>
								</div>
								<div class="col-1 align-self-center" @click="toggleMobileCollapse('guest')">
									<svg width="14" class="svg-property position-relative" :class="{'transform-180':mobile.collapse == 'merchant'}" style="left: -2px;" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"/>
									</svg>
								</div>
								<div class="col-12" v-if="mobile.collapse == 'guest'">
									<div class="mt-3">
										<div
											class="w-100">
											<div class="row pt-2 pb-3 mb-2 no-gutters border-bottom">
												<div class="col-7">
													<p class="mb-0 body-2-2 font-bold text-14">{{$t('hotel.adults.adults')}}</p>
													<p class="mb-0 body-2-2 font-regular text-13">Ages 17 or above</p>
												</div>
												<div class="col-5 text-center mt-1">
													<div class="row py-1 text-right w-100 no-gutters">
														<div class="col-4 text-center">
															<img src="../../assets/img/icon/decrement.png"
																class="cursor-disable border rounded-100 p-2" width="30"
																v-if="filter.guest.adult <= 1">
															<img src="../../assets/img/icon/minus-black.png"
																class="cursor-pointer border rounded-100 p-2" width="30" v-else
																@click="changeQtyGuest('adult','minus')">
														</div>
														<div class="col-4 text-center">
															<p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;left:6px">
																{{filter.guest.adult}}</p>
														</div>
														<div class="col-4 text-center">
															<img src="../../assets/img/icon/plus-black.png"
																class="cursor-pointer border rounded-100 p-2" width="30"
																@click="changeQtyGuest('adult','plus')">
														</div>
													</div>
												</div>
											</div>
											<div class="row pt-2 pb-3 my-2 no-gutters border-bottom">
												<div class="col-7">
													<p class="mb-0 body-2-2 font-bold text-14">{{$t('hotel.children.children')}}</p>
													<p class="mb-0 body-2-2 font-regular text-13">Ages 2 - 16</p>
												</div>
												<div class="col-5 text-center mt-1">
													<div class="row py-1 text-right w-100 no-gutters">
														<div class="col-4 text-center">
															<img src="../../assets/img/icon/decrement.png"
																class="cursor-disable border rounded-100 p-2" width="30"
																v-if="filter.guest.child == 0">
															<img src="../../assets/img/icon/minus-black.png"
																class="cursor-pointer border rounded-100 p-2" width="30" v-else
																@click="changeQtyGuest('child','minus')">
														</div>
														<div class="col-4 text-center">
															<p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;left:6px">
																{{filter.guest.child}}</p>
														</div>
														<div class="col-4 text-center">
															<img src="../../assets/img/icon/plus-black.png"
																class="cursor-pointer border rounded-100 p-2" width="30"
																@click="changeQtyGuest('child','plus')">
														</div>
													</div>
												</div>
											</div>
											<div class="row py-2 no-gutters">
												<div class="col-7">
													<p class="mb-0 body-2-2 font-bold text-14">{{$t('hotel.infants.infants')}}</p>
													<p class="mb-0 body-2-2 font-regular text-13">Under 2</p>
												</div>
												<div class="col-5 text-center mt-1">
													<div class="row py-1 text-right w-100 no-gutters mt-2">
														<div class="col-4 text-center">
															<img src="../../assets/img/icon/decrement.png"
																class="cursor-disable border rounded-100 p-2" width="30"
																v-if="filter.guest.infant == 0">
															<img src="../../assets/img/icon/minus-black.png"
																class="cursor-pointer border rounded-100 p-2" width="30" v-else
																@click="changeQtyGuest('infant','minus')">
														</div>
														<div class="col-4 text-center">
															<p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;left:6px">
																{{filter.guest.infant}}</p>
														</div>
														<div class="col-4 text-center">
															<img src="../../assets/img/icon/plus-black.png"
																class="cursor-pointer border rounded-100 p-2" width="30"
																@click="changeQtyGuest('infant','plus')">
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- PROMO CODE -->
						<div class="p-3 align-self-center bg-white border rounded-6 mb-2 box-shadow-ota-1">
							<div class="row no-gutters cursor-pointer">
								<div class="col-1 align-self-center" @click="toggleMobileCollapse('promo')">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M20.3992 9.14599L21.1194 9.86599C21.6897 10.426 21.9998 11.186 21.9998 11.986C22.0098 12.786 21.6997 13.547 21.1395 14.116C21.1328 14.1233 21.1261 14.1298 21.1194 14.1362C21.1161 14.1394 21.1128 14.1427 21.1094 14.146L20.3992 14.856C20.1191 15.136 19.959 15.516 19.959 15.917V16.946C19.959 18.606 18.6085 19.957 16.9479 19.957H15.9176C15.5174 19.957 15.1373 20.116 14.8572 20.396L14.1369 21.116C13.5467 21.707 12.7764 21.996 12.0061 21.996C11.2359 21.996 10.4656 21.707 9.87537 21.127L9.14511 20.396C8.865 20.116 8.48487 19.957 8.08472 19.957H7.05435C5.39375 19.957 4.04326 18.606 4.04326 16.946V15.917C4.04326 15.516 3.8832 15.136 3.6031 14.846L2.88284 14.136C1.71241 12.967 1.70241 11.056 2.87283 9.87699L3.6031 9.14599C3.8832 8.86599 4.04326 8.48599 4.04326 8.07599V7.05599C4.04326 5.39599 5.39375 4.04699 7.05435 4.04699H8.08472C8.48487 4.04699 8.865 3.88599 9.14511 3.60599L9.86537 2.88599C11.0358 1.70699 12.9465 1.70699 14.1269 2.87699L14.8572 3.60599C15.1373 3.88599 15.5174 4.04699 15.9176 4.04699H16.9479C18.6085 4.04699 19.959 5.39599 19.959 7.05599V8.08699C19.959 8.48599 20.1191 8.86599 20.3992 9.14599ZM9.42521 15.446C9.66529 15.446 9.88537 15.356 10.0454 15.186L15.1873 10.047C15.5274 9.70699 15.5274 9.14599 15.1873 8.80599C14.8472 8.46699 14.297 8.46699 13.9569 8.80599L8.81499 13.946C8.47486 14.286 8.47486 14.846 8.81499 15.186C8.97504 15.356 9.19512 15.446 9.42521 15.446ZM13.6968 14.566C13.6968 15.056 14.0869 15.446 14.5771 15.446C15.0572 15.446 15.4474 15.056 15.4474 14.566C15.4474 14.087 15.0572 13.696 14.5771 13.696C14.0869 13.696 13.6968 14.087 13.6968 14.566ZM9.43521 8.55599C9.91539 8.55599 10.3055 8.94599 10.3055 9.42599C10.3055 9.91699 9.91539 10.306 9.43521 10.306C8.95504 10.306 8.55489 9.91699 8.55489 9.42599C8.55489 8.94599 8.95504 8.55599 9.43521 8.55599Z" fill="#999999"/>
									</svg>
								</div>
								<div class="col-10 col-lg-10 col-xl-8" @click="toggleMobileCollapse('promo')">
									<div class="pl-2">
										<p class="mb-0 font-regular text-13 color-grey">Promo</p>
										<p class="mb-0 text-14 font-semibold text-semi-dark text-truncate mt-3px">{{ filter.promo_code == '' ? '-':filter.promo_code }}</p>
									</div>
								</div>
								<div class="col-1 align-self-center" @click="toggleMobileCollapse('promo')">
									<svg width="14" height="14" class="svg-property position-relative" style="left: -2px;" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"/>
									</svg>
								</div>
								<div class="col-12" v-if="mobile.collapse == 'promo'">
									<div
										class="mt-3">
										<div class="row py-2 mb-2 no-gutters">
											<div class="col-12">
												<p class="mb-2 body-2-2 font-bold text-14">{{$t('hotel.promo.promo-code')}}</p>
												<input type="text" class="form-control body-2-2 font-semibold"
													v-model="filter.promo_code" :placeholder="$t('general.input-here')" value="promo_code" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="px-4 py-3 border-top position-fixed w-100" style="bottom:0px">
					<div class="row">
						<div class="col-6">
							<button @click="resetFilter()" class="w-100 border-none g-btn-primary-ota-outline g-btn-lg radius-0 py-12px text-color-red mr-2" type="button">
								Reset
							</button>
						</div>
						<div class="col-6">
							<button class="w-100 g-btn-primary-ota g-btn-lg radius-0 py-12px border-none" type="button" @click="hitSearch()">
								<svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<circle cx="7.84442" cy="7.84442" r="5.99237" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M12.0122 12.3235L14.3616 14.6667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span>Search</span>
							</button>
						</div>
					</div>
				</div>
			</template>
		</popup-detail>
	</div>
</template>
<script>
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
	import DateRangePicker from 'vue2-daterange-picker';
	import CalendarRoom from '@/components/hotel/be/CalendarRoom'
	import moment from 'moment'
	import { mapGetters } from 'vuex';

	export default{
		props:['merchant_list','backdrop'],
		components:{
			DateRangePicker,
			CalendarRoom
		},
		data(){
			return{
				filter:{
					merchant:{
						list: this.merchant_list,
						selected: {},
						show_detail: false,
					},
					guest:{
						adult: 1,
						child: 0,
						infant: 0
					},
					promo_code: '',
					date:{
						form: {
			        startDate: moment().toDate(),
			        endDate: moment().add(1,'d').toDate(),
			      },
						min: moment().toDate()
					}
				},
				mobile:{
					show: false,
					collapse: ''
				}
			}
		},
		computed:{
			...mapGetters(['getCompanyType','getMerchant','getBeFilter']),
			is_backdrop_for_basic(){
        return this.backdrop == 'merchant' || this.backdrop == 'date' || this.backdrop == 'guest' ? true : false
      }
		},
		watch:{
			backdrop(){
				this.filter.merchant.show_detail = this.backdrop == 'merchant' ? true : false
				if(this.is_backdrop_for_basic && window.innerWidth <= 992){
					this.toggleMobileView()
				}
			}
		},
		mounted(){
			if(this.getCompanyType == 'MERCHANT'){
				this.fillDataFromMerchant()
			}else{
				this.hitSearch()
			}
		},
		methods:{
			applyDateFilter(date){
				this.filter.date.form = date
			},
			fillDataFromMerchant(){
				this.filter.merchant.selected = this.merchant_list.find(x=>x.id==this.getMerchant.id)
				this.filter.date.form = {
					startDate: moment(this.getBeFilter.date.check_in,'YYYY-MM-DD').toDate(),
					endDate: moment(this.getBeFilter.date.check_out,'YYYY-MM-DD').toDate()
				}
				this.filter.guest = this.$deepCopy(this.getBeFilter.guest)
				this.filter.promo_code = this.getBeFilter.promo_code
			},
			toggleDetailMerchant(){
				this.filter.merchant.show_detail = !this.filter.merchant.show_detail
			},
			selectMerchant(data){
				this.filter.merchant.selected = data
				this.toggleDetailMerchant()
				this.toggleMobileCollapse()
			},
			toggleBackdrop(data=''){
				this.$emit("toggleBackdrop", data)
				this.filter.merchant.show_detail = data == 'merchant' ? true : false
	    },
	    changeQtyGuest(field,type){
	    	if(type == 'plus'){
	    		this.filter.guest[field]++
	    	}else{
	    		if((field == 'adult' && this.filter.guest.adult > 1) || (field != 'adult' && this.filter.guest.adult > 0)){
	    			this.filter.guest[field]--
	    		}
	    	}
	    },
	    formatDateNumber(value){
	      return moment(value).format("D")
	    },
	    hitSearch(){
	    	let params = {
	    		merchant: this.filter.merchant.selected,
	    		date:this.filter.date.form,
	    		guest:this.filter.guest,
	    		promo_code: this.filter.promo_code
	    	}
				this.toggleBackdrop()
	    	this.$emit('applyFilter',params)
				this.mobile={
					show: false,
					collapse: ''
				}
	    },
	    clearSelectedProperty(){
	    	this.filter.merchant.selected = {name: 'Choose property'}
	    },
			toggleMobileView(){
				this.mobile.show = !this.mobile.show
				if(!this.mobile.show){
					this.toggleBackdrop('')
				}
			},
			toggleMobileCollapse(data=''){
				this.mobile.collapse = this.mobile.collapse == data ? '' : data
			},
			resetFilter(){
				this.filter={
					merchant:{
						list: this.merchant_list,
						selected: {},
						show_detail: false,
					},
					guest:{
						adult: 1,
						child: 0,
						infant: 0
					},
					promo_code: '',
					date:{
						form: {
			        startDate: moment().toDate(),
			        endDate: moment().add(1,'d').toDate(),
			      },
						min: moment().toDate()
					}
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/community/Filter.vue